export default {"src":"/_next/static/media/Telegram_Icon.95f3bb53.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};